import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

const cutString = (text, count, insertDots) => {
  return text ? text.slice(0, count) + (((text.length > count) && insertDots) ? "..." : "") : "";
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function getInitials(fullName) {
  return fullName
    .split(' ') // Split by space
    .map(word => word.charAt(0).toUpperCase()) // Get first letter and capitalize
    .join(''); // Join letters
}

const onContactClick = () => {
  const number = "+31680068100".replace(/[^\w\s]/gi, "").replace(/ /g, "");
  window.open(`https://web.whatsapp.com/send?phone=${number}`);
};

function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

function setLocalStorage(key, value) {
  window.localStorage.setItem(key, value);
}

const setLocalSession = (key, value, ttlMinutes) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttlMinutes * 60 * 1000,
  };
  window.localStorage.setItem(key, JSON.stringify(item));
  // startSessionTimeout(ttlMinutes, () => {

  //   window.localStorage.setItem(key, JSON.stringify({
  //     value: value,
  //     expiry: -1,
  //   }));
  //   // // Handle logout
  //   // localStorage.clear();
  //   // navigate("/login");
  // })
};

const startSessionTimeout = (durationMinutes, onExpire) => {
  const timeout = setTimeout(() => {
    onExpire();
  }, durationMinutes * 60 * 1000);

  return () => clearTimeout(timeout); // cleanup
};

const getFilteredEventPricingList = (eventPricingList) => {
  const filteredEventPricingList = eventPricingList && Array.isArray(eventPricingList) && eventPricingList.length > 0 ? eventPricingList
    .filter((f) => (f.availableForSale == undefined || (f.availableForSale !== undefined && f.availableForSale == true)) ? true : false)
    .filter((f) => {
      if (
        f.showOnStartDateTime !== undefined &&
        f.showOnEndDateTime !== undefined
      ) {
        const now = dayjs();
        const start = dayjs.unix(f.showOnStartDateTime);
        const end = dayjs.unix(f.showOnEndDateTime);

        return now.isBetween(start, end, null, "[]");
      }
      return true
    }
    ) : []

  return filteredEventPricingList; // cleanup
};

export {
  cutString,
  classNames,
  getInitials,
  onContactClick,
  isValidEmail,
  setLocalSession,
};
